import fetch from "dva/fetch"

const EDUCATE_TOKEN = "educate_token"
function parseJSON(response) {
	console.log("RESPONSE: ", response)
	return response.json()
}

function checkStatus(response) {
	console.log("RESPONSE ya pili: ", response)
	if (response.status >= 200 && response.status < 300) {
		return response
	}
	const error = new Error(response.statusText)
	error.response = response
	throw error
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options) {
	const newOptions = { ...options }
	if (newOptions.method === "POST" || newOptions.method === "PUT") {
		console.log(newOptions.body instanceof FormData)
		if (!(newOptions.body instanceof FormData)) {
			console.log(newOptions)
			localStorage.getItem(EDUCATE_TOKEN)
			newOptions.headers = {
				Accept: "application/json; ",
				"Content-Type": "application/json; charset=utf-8",
				...newOptions.headers,
			}
			newOptions.body = JSON.stringify(newOptions.body)
		} else {
			newOptions.headers = {
				Accept: "application/json",
				"Content-Type": "application/json; charset=utf-8",
				token: localStorage.getItem(EDUCATE_TOKEN),
				...newOptions.headers,
			}
			// newOptions.body = newOptions.body
		}
	} else {
		newOptions.headers = {
			Accept: "application/json",
			"Content-Type": "application/json; charset=utf-8",
			token: localStorage.getItem(EDUCATE_TOKEN),
			...newOptions.headers,
		}
	}
	return fetch(process.env.REACT_APP_SERVER_URL + url, newOptions)
		.then(checkStatus)
		.then(parseJSON)
		.then((data) => {
			console.log("request.js", data)

			if (newOptions.method === "DELETE" || data.status === 204) {
				return data.text()
			}
			return data
		})
		.catch((err) => {
			console.log("ERR", err)
		})
}

export function resetPassword(url, options) {
	const newOptions = { ...options }
	newOptions.headers = {
		Accept: "application/json; ",
		"Content-Type": "application/json; charset=utf-8",
		...newOptions.headers,
	}
	newOptions.body = JSON.stringify(newOptions.body)
	return fetch(process.env.REACT_APP_SERVER_URL + url, newOptions)
		.then(checkStatus)
		.then(parseJSON)
		.then((data) => {
			return data
		})
		.catch((err) => {
			console.log("ERR", err)
		})
}

export function getProfile(url, options) {
	console.log("TOKEN")
	const newOptions = { ...options }
	newOptions.headers = {
		Accept: "application/json; ",
		// 'Content-Type': 'application/json; charset=utf-8',
		authorization: localStorage.getItem(EDUCATE_TOKEN),
		...newOptions.headers,
	}
	return fetch(process.env.REACT_APP_SERVER_URL + url, newOptions)
		.then(checkStatus)
		.then(parseJSON)
		.then((data) => {
			return data
		})
		.catch((err) => {
			console.log("ERR", err)
		})
}

export function addCourse(url, options) {
	console.log("data", options.body)
	const formData = new FormData()
	formData.append("image", options.body.image.originFileObj)
	formData.append("courseName", options.body.courseName)
	formData.append("instructor", options.body.instructor)
	const newOptions = { ...options }
	newOptions.headers = {
		Accept: "application/json",
		...newOptions.headers,
	}
	newOptions.body = formData
	return fetch(process.env.REACT_APP_SERVER_URL + url, newOptions)
		.then(checkStatus)
		.then(parseJSON)
		.then((data) => {
			return data
		})
		.catch((err) => {
			console.log("ERR", err)
		})
}

export function userActions(url, options) {
	const newOptions = { ...options }
	console.log(newOptions)
	const id = options.body.id
	if (newOptions.method === "GET") {
		return fetch(process.env.REACT_APP_SERVER_URL + url + "?id=" + id)
			.then(checkStatus)
			.then(parseJSON)
			.then((data) => {
				return data
			})
			.catch((err) => {
				console.log("ERR", err)
			})
	} else {

		newOptions.headers = {
			Accept: "application/json",
			...newOptions.headers,
		}

		return fetch(
			process.env.REACT_APP_SERVER_URL + url + "?id=" + id,
			newOptions
		)
			.then(checkStatus)
			.then(parseJSON)
			.then((data) => {
				return data
			})
			.catch((err) => {
				console.log("ERR", err)
			})
	}
}

export function addVideo(url, options) {

	const formData = new FormData()
	formData.append("video", options.body.image)
	formData.append("videoName", options.body.videoName)
	formData.append("videoDescription", options.body.videoDescription)
	formData.append("category_id", options.body.category_id)
	formData.append("user_id", options.body.user_id)
	const newOptions = { ...options }
	newOptions.headers = {
		Accept: "application/json",
		...newOptions.headers,
	}
	newOptions.body = formData
	return fetch(process.env.REACT_APP_SERVER_URL + url, newOptions)
		.then(checkStatus)
		.then(parseJSON)
		.then((data) => {
			return data
		})
		.catch((err) => {
			console.log("ERR", err)
		})
}
